<script>
  import Tabs from '../../components/Tabs.svelte'
  import SiteReviews from '../SiteReviews/SiteReviews.svelte'
  import ProductReviews from '../ProductReviews/ProductReviews.svelte'
  import Questions from '../Questions/Questions.svelte'

  export let settings
  export let isFreeUser
  export let data
  export let summary
  export let activeTab
  export let items = []
</script>

<style>
  .tab-content {
    height: 372px;
    overflow-y: auto;
    scrollbar-color: #aab3bd #f0f3f5;
    scrollbar-width: thin;
  }

  .tab-content::-webkit-scrollbar {
    width: 5px;
  }

  .tab-content::-webkit-scrollbar:horizontal,
  ::-webkit-scrollbar:vertical {
    height: 3px;
  }

  .tab-content::-webkit-scrollbar-track {
    background: #f0f3f5;
  }
  .tab-content::-webkit-scrollbar-thumb {
    background: #aab3bd;
  }
  .tab-content::-webkit-scrollbar-thumb:hover {
    background: var(--primaryColor);
  }
</style>

<section>
  <Tabs {activeTab} textColor="#000000" {items} on:tabChanged />
  <div
    class="$style.tab-content"
    style="--primaryColor:{settings.widget_settings.general_settings.primary_color};">
    {#if items[0].show && activeTab === items[0].label}
      <SiteReviews
        siteReviews={data.siteReviews}
        {settings}
        totalReviews={summary.siteReviews.count}
        {isFreeUser} />
    {:else if items[1].show && activeTab === items[1].label}
      <ProductReviews
        reviews={data.productReviews}
        {settings}
        totalReviews={summary.productReviews.count}
        {isFreeUser} />
    {:else if items[2].show && activeTab === items[2].label}
      <Questions
        questions={data.questions}
        {settings}
        totalQuestions={summary.questions.count} />
    {/if}
  </div>
</section>
